import { User } from "@prisma/client";
import { AvatarProps } from "@radix-ui/react-avatar";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Icons } from "@/components/shared/icons";

interface UserAvatarProps extends AvatarProps {
  user: Pick<User, "image" | "name">;
}

export function UserAvatar({ user, ...props }: UserAvatarProps) {
  const avatarSrc = user.image || "/_static/avatars/default-avatar.jpg";

  return (
    <Avatar {...props}>
      <AvatarImage
        alt={user.name || "User avatar"}
        src={avatarSrc}
        referrerPolicy="no-referrer"
      />
      <AvatarFallback>
        <span className="sr-only">{user.name || "User"}</span>
        <Icons.user className="size-4" />
      </AvatarFallback>
    </Avatar>
  );
}
